import React, { Component } from 'react';
import Service from '../api/Service';
import './DataSelectList.css';
import {SelectList, FormDataObj, FormItemBase} from './FormUI';
import NameSelectList from './NameSelectList';
import Clinic from '../api/Clinic';
import User from '../api/User';

import Highlight from 'react-highlighter';
//import {Dropdown} from 'semantic-ui-react';

import countries from './countries.json';
import ClinicService from '../api/services/ClinicService';
import AccountService from '../api/services/AccountService';
import PatientService from '../api/services/PatientService';
import LookupService from '../api/services/LookupService';
import AppointmentTypeService from '../api/services/AppointmentTypeService';
import PhysicianService from '../api/services/PhysicianService';
import AutoCompleteInput from './AutoCompleteInput';
import ClinicPatientList from './datalists/ClinicPatientList';
import AppointmentType from "../api/AppointmentType";



export default class DataSelectList extends Component {
	constructor(props){
		super(props);
		this.state = {};
		this.service = new Service(this.props.caching, this.props.cacheId);
		this.updateValue = this.updateValue.bind(this);
		//console.log("Data Select List:", this.props);
	}

	apiFetch() {
		let apiPath = this.props.service + "/" + this.props.get;
		this.service.request(apiPath, this.props.options, (json) => {
			this.setState({options : this.parseValue(json)});
		})
	}


	parseValue(val) {
		var valueProp = this.props.value || "id";
		var displayName = this.props.name || "displayName";
		const options = val.map(function(item){
			return {value: item[valueProp], label: item[displayName]};
		});
		return options;
	}

	componentWillMount() {
		this.apiFetch();
	}

	updateValue(newValue){
		this.setState({value: newValue});
		this.rememberSelection(newValue);
		if(this.props.onChange){
			this.props.onChange(newValue);
		}
	}



	render() {
		let isLoading = (this.state.options === null);
		let {options, ...props} = this.props;
		return (
			<SelectList options={this.state.options} onChange={this.props.onChange} value={this.state.value} memoryId={this.props.service + '/' + this.props.get}  isLoading={isLoading} />
		);
	}
}

export class CountrySelectList extends Component {
	render() {

		return (
			<SelectList options={countries}  valueKey='code' labelKey='name' {... this.props} />
		/*<DataSelectList service="lookup" get="countries" value="code" name="displayName" caching={true} cacheId="lookup" onChange={this.props.onChange} memoryId={this.props.memoryId} />*/
		);
	}
}

export class ProvinceSelectList extends Component{
    state = {};
    constructor(props){
    	super(props);
    	this.service = new LookupService();
    }
    componentDidMount(){
    	this.service.getProvinces().then((p) => {
    		this.setState({options:p});
    	});
    }
    render() {
    	let {options, ...props} = this.props;
    	return (
    		<SelectList options={this.state.options} valueKey='code' labelKey='displayName' {... props} />
    	);
    }
}

export class ClinicSelectList extends Component{
	render() {
		return (
			<DataSelectList service="lookup" get="clinic" value="id" name="displayName" onChange={this.props.onChange}  caching={true} cacheId="lookup" memoryId={this.props.memoryId} />
		);
	}
}


export class RelatedClinics extends Component{
	constructor(props){
		super(props);
		this.state = {};
		let account = new AccountService();
		let clinics = account.clinics;
		let currentClinicId = account.clinicId;
		let options = [];

		for(let i=0; i < clinics.length; i++){
			let clinic = clinics[i];
			let opt = {label:clinic.name, value:clinic.clinicId};
			options.push(opt);

			if(clinic.clinicId === currentClinicId){
				this.state.currentClinic = opt;
			}

		}

		this.handleChange = this.handleChange.bind(this);

		this.state.options = options;
		this.state.memoryId = 'ACC' + account.userId + '/RelatedClinics';
	}

	handleChange(v){
		//this.state.currentClinic = v;

		this.setState({currentClinic:v})
		if(this.props.onChange && v && v.value != this.state.currentClinic.value){
			this.props.onChange(v.value);
		}
	}

	render(){
		return(
			<SelectList dataObj={this.props.dataObj} name={this.props.name} options={this.state.options} value={this.state.currentClinic} onChange={this.handleChange} memoryId={this.state.memoryId} isLoading={this.props.isLoading} clearable={false} searchable={false} />
		)
	}
}

export class ClinicDoctors extends Component{
	constructor(props){
		super(props);
		this.state = {};
		this.account = new AccountService();
		this.service = new ClinicService();

		this.handleInfo = this.handleInfo.bind(this);

		this.state.user = this.props.value || this.account.userId;// {value:this.account.userId, label:this.account.firstName + " " + this.account.lastName} ;



		this.handleChange = this.handleChange.bind(this);

		//console.log("Clinic Doctors:", clinicId)
	}

	componentDidMount(){
		this.loadInfo();
	}

	loadInfo(cid){
		this.setState({isLoading:true});
		let clinicId = cid || this.props.clinicId || this.account.clinicId;

		//this.service.getInfo(clinicId).then(this.handleInfo);
		ClinicService.GetDoctors(clinicId).then(this.handleInfo);
	}

	handleInfo(json){

		//console.log("ClinicService.GetDoctors:", ClinicService.GetDoctors());

		let options = [];
		let doctors = json;
		for(let i=0; i < doctors.length; i++){
			let user = doctors[i];
			options.push({label: user.firstName + " " + user.lastName, value:user.userId});
		}

		this.state.options = options;

		this.setState({options:options, isLoading:false, clinicId:this.props.clinicId});
		//console.log("New CLinic List Loaded:", this.props.clinicId);
	}

	handleChange(v){
		if(v == null)return;
		if(this.props.onChange){
			this.props.onChange(v.value, v.label);
		}
	}

	/*shouldComponentUpdate(nextProps, nextState, nextContext){
        console.log("Should Update:", nextProps, nextState, nextContext);

        //if(!this._firstRender)return true;

        if(nextProps.clinicId != this.props.clinicId){
            this.loadInfo();
            return false;
        }


        return true;
    }*/

	componentWillReceiveProps(props){
		if(props.clinicId != this.props.clinicId){
			this.loadInfo(props.clinicId);
			console.log("Loading New Clinic Doctors")
		}
	}

	render(){
		//console.log("Clinic Doctors Render:", this.props.clinicId);
		/*if(this.props.clinicId !== this.state.clinicId && !this.state.isLoading){
            this.loadInfo();
        }*/
		// this._firstRender = true;
		let {options, onChange, value, isLoading, placeholder, ...props} = this.props;
		return(
			<NameSelectList options={this.state.options} onChange={this.handleChange} value={this.state.user} isLoading={this.state.isLoading} placeholder={this.props.placeholder || 'Select Pedorthist'} {...props} />
		)
	}
}


export class AppointmentTypeList extends Component{
	constructor(props){
		super(props);
		let account = new AccountService();
		let appTypes = AppointmentTypeService.GetAppTypes();// (new Clinic(account.clinicId)).appTypes.getAll();

		console.log('App Types:', appTypes);
		let options = [];

		for(let i=0; i < appTypes.length; i++){
			let app = new AppointmentType(appTypes[i]);
			options.push({label:app.name, value:app.appointmentTypeId})
		}

		/*options.sort((a, b) => {
            if(a.label < b.label)return -1

            if(a.label > b.label)return 1;

            return 0;
        })*/


		this.state = {
			options: options,
			value: this.props.value
		}
	}

	render(){
		let {options, onChange, value, ...props} = this.props;

		return(

			<SelectList options={this.state.options} onChange={this.props.onChange} value={this.state.value} {...props} />

		)
	}
}
export class AppointmentCategoryList extends Component{

	getOptions(){
		let cats = AppointmentTypeService.GetCategoryCache().getAll();
		let opts = [];
		for(let i=0; i < cats.length; i++){
			let cat = cats[i];
			opts.push({label:cat.categoryName, value:cat.appointmentCategoryId});
		}
		return opts;
	}

	render(){
		let {options, ...props} = this.props;

		return(
			<SelectList options={this.getOptions()} simpleValue={true} {...props} />
		)
	}
}

export class StatusSelectList extends Component{
	constructor(props){
		super(props);
		this.state = {
			options:[
				{label:'Booked', value:'Booked'},
				{label:'Confirmed', value:'Confirmed'},
				{label:'Cancelled', value:'Cancelled'},
				{label:'No-Show', value:'No-Show'},
				{label:'Completed', value:'Completed'}
			]
		}
	}

	render(){
		return(
			<SelectList options={this.state.options} {... this.props}  />
		)
	}
}
const userPropNames = {
	'cellPhone': 'C',
	'homePhone': 'H',
	'workPhone': 'W',
	'email': 'Email',
}
/*export class ClinicPatientList extends Component{
    state = {};

    constructor(props){
        super(props);
        this.filterOption = this.filterOption.bind(this);
        this.optionRenderer = this.optionRenderer.bind(this);
    }

    componentDidMount(){
        this.loadList();
    }


    loadList(noCache){
        if(this.state.isBusy)return;

        let p = new PatientService();
        this.setState({isBusy:true})
        p.getAll(noCache).then((data) => {
            let options = [];
            for(let i=0; i < data.length; i++){
                options.push(new User(data[i]));
            }
            this.setState({options:options, isBusy:false});
            if(this.props.onLoaded){
                this.props.onLoaded(options);
            }
        });
    }

    componentWillReceiveProps(props){
        if(props.reload && props.reload !== this.props.reload){
            this.loadList(true);
        }
    }

    filterOption(option, filter){
        return this.getMatchingProps(option, filter);
    }

    getMatchingProps(user, search, getList){
        let compareProps = ['fullName', 'homePhone','cellPhone', 'workPhone', 'email', 'address1', 'address2'];
        let found = [];
        let s = search.toLowerCase();
        for(let i=0; i < compareProps.length; i++){
            let val = user[compareProps[i]];
            if(val){
                if(val.toLowerCase().indexOf(s) !== -1){
                    if(getList){
                        found.push(compareProps[i]);
                    }else{
                        return true;
                    }

                }
            }
        }


        return getList? found:false;
    }

    optionRenderer(option, index, filter){
        //console.log("Option Render:", arguments);
        if(filter){
            let user = option;
            let matchingProps = this.getMatchingProps(option, filter, true);
            let addressUsed = false;
            let o = [];
            for(let i=0; i < matchingProps.length; i++){
                let p = matchingProps[i];
                if(p !== 'fullName'){
                    switch(p){
                        case 'address1':
                        case 'address2':
                            if(addressUsed)continue;
                            o.push(
                                <div>
                                    <div>Address</div>
                                    <div><Highlight search={filter}>{option['address1']}</Highlight> </div>
                                    <div><Highlight search={filter}>{option['address2']}</Highlight> </div>
                                </div>
                            )
                            addressUsed = true;
                        break;
                        default:
                            o.push(<div>{userPropNames[p] || p} :<Highlight search={filter}>{option[p]}</Highlight> </div>);
                        break;
                    }

                }
            }
            return <div>
                        <span><Highlight search={filter}>{option.fullName}</Highlight></span>
                        {o}
                    </div>;
        }
        return option.fullName;
    }



    render(){
        let {reload, onLoaded, options, ...props} = this.props;
        return(
            <SelectList options={this.state.options} optionRenderer={this.optionRenderer} filterOption={this.filterOption} isLoading={this.state.isBusy} labelKey='fullName' valueKey='clientId' {... props} />
        );
    }
}*/


/*** Assync Version  */

/*export class ClinicPatientList extends FormItemBase{
    state = {};

    constructor(props){
        super(props);
        this.filterOption = this.filterOption.bind(this);
        this.optionRenderer = this.optionRenderer.bind(this);
    }

    get service(){
        return PatientService;
    }


    filterOption(option, filter){
        return true;//option;// this.getMatchingProps(option, filter);
    }

    getMatchingProps(user, search, getList){
        let compareProps = ['fullName', 'homePhone','cellPhone', 'workPhone', 'email', 'address1', 'address2'];
        let found = [];
        let s = search.toLowerCase();
        for(let i=0; i < compareProps.length; i++){
            let val = user[compareProps[i]];
            if(val){
                if(val.toLowerCase().indexOf(s) !== -1){
                    if(getList){
                        found.push(compareProps[i]);
                    }else{
                        return true;
                    }
                }
            }
        }


        return getList? found:false;
    }

    optionRenderer(option, index, filter){
            //console.log("Option Render:", option);

            let user = option;
            let matchingProps = this.getMatchingProps(option, filter, true);
            let addressUsed = false;
            let o = [];
            for(let i=0; i < matchingProps.length; i++){
                let p = matchingProps[i];
                if(p !== 'fullName'){
                    switch(p){
                        case 'address1':
                        case 'address2':
                            if(addressUsed)continue;
                            o.push(
                                <div>
                                    <div>Address</div>
                                    <div><Highlight search={filter}>{option['address1']}</Highlight> </div>
                                    <div><Highlight search={filter}>{option['address2']}</Highlight> </div>
                                </div>
                            )
                            addressUsed = true;
                        break;
                        default:
                            o.push(<div>{userPropNames[p] || p} :<Highlight search={filter}>{option[p]}</Highlight> </div>);
                        break;
                    }

                }
            }
            return <div>
                        <span><Highlight search={filter}>{option.fullName}</Highlight></span>
                        {o}
                    </div>;

        //return option.fullName;
    }


    getSingle = (patientId) => {
        return this.service.GetById(patientId).then((client) =>{
            return new User(client);
        });
    }

    getSearch = (term) => {
        if(!term.trim())return Promise.resolve([]);
        return this.service.Search(term).then((json) => {
            return json.map((user) => new User(user));
        })
    }

    formatResultForOptions = (json) =>{
        let options = [];
        for(let i=0; i < json.length; i++){
            options.push(new User(json[i]));
        }
        return {options:options};
    }

    getOptions = (input) =>{


        return this.getSearch(input);
    }

    handleOnChange = (val) =>{
        this.setState({options:[val]});
        if(this.props.onChange){
            this.props.onChange(val)
        }
    }

    valueRenderer = (user) => {
        return user.fullName;
    }



    handleOptionSelect = (user, skipCB)=>{
        this.setState({user:user});
        this._onValueChanged(user.clientId);
        if(this.props.onOptionSelect && !skipCB){
            this.props.onOptionSelect(user);
        }
    }

    componentDidMount(){
        if(this.props.user){
            this.handleOptionSelect(this.props.user, true);
        }
    }


    render(){
        let {reload, onLoaded, options, form, onOptionSelect, ...props} = this.props;
        let label = (this.state.user || {}).fullName || '';
        return(
            <AutoCompleteInput value={this.state.user} onOptionSelect={this.handleOptionSelect} loadOptions={this.getOptions} valueRenderer={this.valueRenderer} optionRenderer={this.optionRenderer} {... props} />
        );
    }

}*/

/*export class ClinicPhysicianList extends ClinicPatientList{

    get service(){
        return PhysicianService;
    }

}*/

/*
export class ClinicPhysicianList extends Component{
    state = {};
    getOptions = (input) =>{
        if(!input.trim())return Promise.resolve([]);

        return PhysicianService.search(input).then((json) =>{
            let options = [];
            for(let i=0; i < json.length; i++){
                options.push(new User(json[i]));
            }
            return {options:options};
        })
    }

    render(){
        let {loadOptions, isAsync, ...props} = this.props;
        return(
            <SelectList loadOptions={this.getOptions} isAsync={true} {...props} labelKey='fullName' valueKey='clientId' />
        )
    }
}*/



// WEBPACK FOOTER //
// ./src/components/DataSelectList.js